import { render, staticRenderFns } from "./wallet_qrcode.vue?vue&type=template&id=0c100fc5&scoped=true"
import script from "./wallet_qrcode.vue?vue&type=script&lang=js"
export * from "./wallet_qrcode.vue?vue&type=script&lang=js"
import style0 from "./wallet_qrcode.vue?vue&type=style&index=0&id=0c100fc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c100fc5",
  null
  
)

export default component.exports